import { RouteObject } from "react-router-dom";
import { PageLayoutDefaultMenuNavigationGroup } from "@sis/react-library"
import ListIcon from '@mui/icons-material/List';
import { ListAndDetailSamplesAboutPage } from "./listAndDetailSamplesPages/ListAndDetailSamplesAboutPage";
import { ListAndDetailSamplesBasicPage } from "./listAndDetailSamplesPages/listAndDetailSamplesBasicPage/ListAndDetailSamplesBasicPage";
import { ListAndDetailSamplesBasicEditPage } from "./listAndDetailSamplesPages/listAndDetailSamplesBasicPage/ListAndDetailSamplesBasicEditPage";
import { ListAndDetailSamplesCustomRenderPage } from "./listAndDetailSamplesPages/listAndDetailSamplesCustomRenderPage/ListAndDetailSamplesCustomRenderPage";
import { ListAndDetailSamplesCustomRenderEditPage } from "./listAndDetailSamplesPages/listAndDetailSamplesCustomRenderPage/ListAndDetailSamplesCustomRenderEditPage";
import { ListAndDetailSamplesFiltersPage } from "./listAndDetailSamplesPages/listAndDetailSamplesFiltersPage/ListAndDetailSamplesFiltersPage";
import { ListAndDetailSamplesFiltersEditPage } from "./listAndDetailSamplesPages/listAndDetailSamplesFiltersPage/ListAndDetailSamplesFiltersEditPage";
import { ListAndDetailSamplesCustomizePage } from "./listAndDetailSamplesPages/listAndDetailSamplesCustomizePage/ListAndDetailSamplesCustomizePage";
import { ListAndDetailSamplesCustomizeEditPage } from "./listAndDetailSamplesPages/listAndDetailSamplesCustomizePage/ListAndDetailSamplesCustomizeEditPage";
import { ListAndDetailSamplesCustomizeViewPage } from "./listAndDetailSamplesPages/listAndDetailSamplesCustomizePage/ListAndDetailSamplesCustomizeViewPage";
import { ListAndDetailSamplesPaginationPage } from "./listAndDetailSamplesPages/listAndDetailSamplesPaginationPage/ListAndDetailSamplesPaginationPage";
import { ListAndDetailSamplesPaginationEditPage } from "./listAndDetailSamplesPages/listAndDetailSamplesPaginationPage/ListAndDetailSamplesPaginationEditPage";
import { ListAndDetailSamplesAdditionalActionsPage } from "./listAndDetailSamplesPages/listAndDetailSamplesAdditionalActionsPage/ListAndDetailSamplesAdditionalActionsPage";
import { ListAndDetailSamplesAdditionalActionsEditPage } from "./listAndDetailSamplesPages/listAndDetailSamplesAdditionalActionsPage/ListAndDetailSamplesAdditionalActionsEditPage";
import { MultipleListsNavigation } from "./listAndDetailSamplesPages/listAndDetailSamplesMultipleListsPage/ListAndDetailSamplesMultipleListsNavigation";
import { ListAndDetailSamplesGroupingsPage } from "./listAndDetailSamplesPages/listAndDetailSamplesGroupingsPage/ListAndDetailSamplesGroupingsPage";
import { ListAndDetailSamplesGroupingsEditPage } from "./listAndDetailSamplesPages/listAndDetailSamplesGroupingsPage/ListAndDetailSamplesGroupingsEditPage";

const url = "listAndDetailSamples";

// Allow in same file
// eslint-disable-next-line
export const listAndDetailSamplesRoutes = {
    about: `/${url}/about`,
    basic: `/${url}/basic`,
    customRender: `/${url}/customRender`,
    filters: `/${url}/filters`,
    groupings: `/${url}/groupings`,
    additionalActions: `/${url}/additionalActions`,
    customize: `/${url}/customize`,
    pagination: `/${url}/pagination`,
    multipleLists: `/${url}/multipleLists`,

    new: "new",
    edit: "edit/",
    view: "view/",
    match: ":cityTownCode",
    matchId: ":id",
}

// Allow in same file
// eslint-disable-next-line
export const listAndDetailSamplesRoutesCombined = {
    basic_editMatch: `${listAndDetailSamplesRoutes.basic}/${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
    customRender_editMatch: `${listAndDetailSamplesRoutes.customRender}/${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
    filters_editMatch: `${listAndDetailSamplesRoutes.filters}/${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
    groupings_editMatch: `${listAndDetailSamplesRoutes.groupings}/${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
    additionalActions_editMatch: `${listAndDetailSamplesRoutes.additionalActions}/${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
    customize_editMatch: `${listAndDetailSamplesRoutes.customize}/${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
    customize_viewMatch: `${listAndDetailSamplesRoutes.customize}/${listAndDetailSamplesRoutes.view}${listAndDetailSamplesRoutes.match}`,
    pagination_editMatch: `${listAndDetailSamplesRoutes.pagination}/${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.matchId}`
}

export const ListAndDetailsSamplesNavigation = (): RouteObject[] => {
    return [
        {
            path: listAndDetailSamplesRoutes.about,
            element: <ListAndDetailSamplesAboutPage />
        },
        {
            path: listAndDetailSamplesRoutes.basic,
            element: <ListAndDetailSamplesBasicPage />,
            children: [
                {
                    path: `${listAndDetailSamplesRoutes.new}`,
                    element: <ListAndDetailSamplesBasicEditPage />
                },
                {
                    path: `${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
                    element: <ListAndDetailSamplesBasicEditPage />
                }
            ]
        },
        {
            path: listAndDetailSamplesRoutes.customRender,
            element: <ListAndDetailSamplesCustomRenderPage />,
            children: [
                {
                    path: `${listAndDetailSamplesRoutes.new}`,
                    element: <ListAndDetailSamplesCustomRenderEditPage />
                },
                {
                    path: `${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
                    element: <ListAndDetailSamplesCustomRenderEditPage />
                }
            ]
        },
        {
            path: listAndDetailSamplesRoutes.filters,
            element: <ListAndDetailSamplesFiltersPage />,
            children: [
                {
                    path: `${listAndDetailSamplesRoutes.new}`,
                    element: <ListAndDetailSamplesFiltersEditPage />
                },
                {
                    path: `${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
                    element: <ListAndDetailSamplesFiltersEditPage />
                }
            ]
        },
        {
            path: listAndDetailSamplesRoutes.groupings,
            element: <ListAndDetailSamplesGroupingsPage />,
            children: [
                {
                    path: `${listAndDetailSamplesRoutes.new}`,
                    element: <ListAndDetailSamplesGroupingsEditPage />
                },
                {
                    path: `${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
                    element: <ListAndDetailSamplesGroupingsEditPage />
                }
            ]
        },
        {
            path: listAndDetailSamplesRoutes.additionalActions,
            element: <ListAndDetailSamplesAdditionalActionsPage />,
            children: [
                {
                    path: `${listAndDetailSamplesRoutes.new}`,
                    element: <ListAndDetailSamplesAdditionalActionsEditPage />
                },
                {
                    path: `${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
                    element: <ListAndDetailSamplesAdditionalActionsEditPage />
                }
            ]
        },
        {
            path: listAndDetailSamplesRoutes.customize,
            element: <ListAndDetailSamplesCustomizePage />,
            children: [
                {
                    path: `${listAndDetailSamplesRoutes.new}`,
                    element: <ListAndDetailSamplesCustomizeEditPage />
                },
                {
                    path: `${listAndDetailSamplesRoutes.view}${listAndDetailSamplesRoutes.match}`,
                    element: <ListAndDetailSamplesCustomizeViewPage />
                },
                {
                    path: `${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.match}`,
                    element: <ListAndDetailSamplesCustomizeEditPage />
                }
            ]
        },
        {
            path: listAndDetailSamplesRoutes.pagination,
            element: <ListAndDetailSamplesPaginationPage />,
            children: [
                {
                    path: `${listAndDetailSamplesRoutes.new}`,
                    element: <ListAndDetailSamplesPaginationEditPage />
                },
                {
                    path: `${listAndDetailSamplesRoutes.edit}${listAndDetailSamplesRoutes.matchId}`,
                    element: <ListAndDetailSamplesPaginationEditPage />
                }
            ]
        },
        ...MultipleListsNavigation()
    ]
}

// Allow in same file
// eslint-disable-next-line
export const ListAndDetailsSamplesMenuItem: PageLayoutDefaultMenuNavigationGroup = {
    icon: <ListIcon />, text: 'List and Detail', items: [
        { text: 'About', navigateTo: listAndDetailSamplesRoutes.about },
        { text: 'Basic', navigateTo: listAndDetailSamplesRoutes.basic },
        { text: 'Custom Render', navigateTo: listAndDetailSamplesRoutes.customRender },
        { text: 'Filters', navigateTo: listAndDetailSamplesRoutes.filters },
        { text: 'Grouping', navigateTo: listAndDetailSamplesRoutes.groupings },
        { text: 'Additional Actions', navigateTo: listAndDetailSamplesRoutes.additionalActions },
        { text: 'Customize', navigateTo: listAndDetailSamplesRoutes.customize },
        { text: 'Pagination', navigateTo: listAndDetailSamplesRoutes.pagination },
        { text: 'Multiple Lists', navigateTo: listAndDetailSamplesRoutes.multipleLists }
    ]
}
